"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardPhotoWrapper = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCardPhotoWrapper = require("./PropertyCardPhotoWrapper.styles");
/**
 * Used by a `PropertyCard` to contain all of the parts of the property photo area
 * including the photo, badges and MLS information.
 *
 * @since 8.63.0
 */
var PropertyCardPhotoWrapper = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PropertyCardPhotoWrapper.StyledPropertyCardPhotoWrapper, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.PropertyCardPhotoWrapper = PropertyCardPhotoWrapper;
PropertyCardPhotoWrapper.displayName = 'PropertyCard.PhotoWrapper';